module.exports = __webpack_public_path__ + "static/img/zzrz05.236dfa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zzrz05.jpg
// module id = 2s/u
// module chunks = 1